import React from 'react'
import Card from 'react-bootstrap/Card'
import Axios from 'axios'
import Cookies from 'universal-cookie'

const cookies = new Cookies()
const user_id = cookies.get('user_id')

const secondaryTag = {
    position: 'absolute',
    background: '#2e3192',
    color: 'white',
    bottom: '0px',
    right: '0px',
    fontSize: '1.25rem',
    padding: '0.25rem'
}
 
const EstateCard = (props) => {
    const dataUser = (props.api_key) ? JSON.parse(window.atob(props.api_key)): null;
    const confirm = () => {
        const confirmation = window.confirm('¿Estás seguro(a) que deseas borrar esta propiedad? Esta acción no se puede deshacer')
        if (confirmation) {
            deleteEstate()
        }
    }

    const deleteEstate = () => {
        let endpoint = props.base_url + "endpoint/estate"
        Axios.post(endpoint, { operation: "delete_estate", api_key: props.api_key, estate_id: props.cardData.estate_id })
            .then(res => {
                console.log(res.data)
                props.FetchList()
            })
    }
    return (
        
        <Card className="card-hover" style={{ borderRadius: '0px' }}>
            <div style={{ position: 'relative' }}>
                <Card.Img
                  style={{ borderRadius: '0px', cursor: 'pointer' }}
                  variant="top"
                  src={props.base_url + 'endpoint/images/estates/list/' + props.cardData.image}
                  alt="Property preview"
                  onClick={() => props.viewEstateDetails(props.cardData)}
                />
                <span
                  style={{ ...secondaryTag, cursor: 'pointer' }}
                  onClick={() => props.viewEstateDetails(props.cardData)}
                >
                  {props.cardData.zone + ', ' + props.cardData.state}
                </span>
            </div>
            
            <Card.Body onClick={() => props.viewEstateDetails(props.cardData)} style={{ cursor: 'pointer' }}>
            
                <Card.Title>{props.cardData.title}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">{props.cardData.transaction}</Card.Subtitle>
                <Card.Subtitle className="mb-2 text-muted">{props.cardData.asking_price}</Card.Subtitle>
                <Card.Text>
                    {props.cardData.description}
                </Card.Text>

                <div style={{ display: 'flex' }}>
                    {props.editable &&
                        <>
                            {dataUser && parseInt(dataUser.permiso) === 3 &&
                                <div style={{ marginLeft: 'auto' }}>
                                    <button onClick={() => props.updateEstate(props.cardData)} className="btn btn-sm btn-warning mr-1" ><span className="material-icons">update</span></button>
                                    <button onClick={confirm} className="btn btn-danger btn-sm"><span className="material-icons">delete</span></button>
                                </div>

                            }
                        </>
                    }

                </div>


            </Card.Body>
        </Card>
    )
}
export default EstateCard